import { useProfile } from "contexts/ProfileContext";
import Icon from "core/components/Icon";
import * as MdIcons from "react-icons/md";
import iconeUsuario from "../../../images/iconeUsuario.png";

function MobileTopBar({
	onMenuClick,
	title,
}: {
	onMenuClick: () => void;
	title: string;
}) {
	const { profile, coresEmpresa } = useProfile();
	return (
		<div
			className="navbar-mobile"
			style={{ backgroundColor: coresEmpresa.headerFooter }}
		>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					width: "100%",
				}}
			>
				<div onClick={onMenuClick} style={{ cursor: "pointer", padding: 8 }}>
					<MdIcons.MdMenu size={24} color="#fff" />
				</div>
				<div
					className="title-menu-mobile"
					style={{ textAlign: "center", flex: 1 }}
				>
					{title}
				</div>
				<div className="image-perfil" style={{ marginLeft: 12 }}>
					{profile?.profileImage ? (
						<img
							src={
								profile?.profileImage && profile?.profileImage.tipo
									? `data:${profile?.profileImage.tipo};base64,${profile?.profileImage.dado}`
									: iconeUsuario
							}
							alt="Uploaded preview"
						/>
					) : (
						<Icon name="User" size="xl" theme="light" />
					)}
				</div>
			</div>
		</div>
	);
}

export default MobileTopBar;
